"use strict";

const accessibleDialog = require("./accessibleDialog");

/**
 * Shows the "added to wishlist" confirmation modal.
 *
 * Kept out of product/wishlistHeart.js on purpose: that module is loaded with processInclude, which
 * calls every function it exports on page load, so exporting this from there opened the
 * confirmation on every PDP and PLP (DGF-4872).
 */
function showAddedToWishlistConfirmation() {
    // Auto-launched confirmation with no trigger of its own (DGF-3989).
    accessibleDialog.open($(".modal.add-to-wishlist"), {
        show: function (dialog) {
            $(dialog).addClass("show");
            $(".modal-add-to-bag-backdrop").addClass("show");
        },
        // Name the dialog from its title line only. The body comes from a content asset
        // and naming the whole of it makes the reader recite every sentence (DGF-3989).
        titleSelector: ".add-to-wishlist-body",
        initialFocus: ".close-modal",
        onClose: function (dialog) {
            $(dialog).removeClass("show");
            $(".modal-add-to-bag-backdrop").removeClass("show");
        }
    });
}

module.exports = {
    showAddedToWishlistConfirmation: showAddedToWishlistConfirmation
};
